import { jumpPageUrl } from '@src/utils/';

// @ts-ignore

export const RuleUrl = `${jumpPageUrl()}/rule`;

export const PlayUrl = `${jumpPageUrl()}/play`;

export const IndexUrl = `${jumpPageUrl()}/index`;

export const WenjuanUrl = `${jumpPageUrl()}/wenjuan`;

export const VoteUrl = `${jumpPageUrl()}/choujiang`;

export const LoginUrl = `${jumpPageUrl()}/login`;

export const SurveyUrl = `${jumpPageUrl()}/survey`;

export const AdUrl = 'https://mall.jd.com/index-12314412.html';

